import styled from "styled-components";

export const StyledCheckboxField = styled.input`
  width: 20px;
  height: 20px;
  margin: 0 20px 10px 0;
`;
